import { UserForm } from '@/components/enc/user-form';
import { useParams } from 'react-router-dom';

const EditPage = () => {
  const { id } = useParams<{ id: string }>();

  return <UserForm key={id} id={id} />;
};

export default EditPage;
